import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';

const useCardTemplateAttributeDbs = (cardTemplateId: string): [string[], (CardTemplateAttributeDb | CardTemplateShapeDb)[]] => {
  const cardTemplateAttributeDb = useSelector((state: RootState) => state.cardTemplateAttributeDb);
  const cardTemplateShapeDb = useSelector((state: RootState) => state.cardTemplateShapeDb);
  const attributeIds = Object.keys(cardTemplateAttributeDb.cardTemplateAttributes).filter(id => cardTemplateAttributeDb.cardTemplateAttributes[id].cardTemplateId === cardTemplateId);
  const shapeIds = Object.keys(cardTemplateShapeDb.cardTemplateShapes).filter(id => cardTemplateShapeDb.cardTemplateShapes[id].cardTemplateId === cardTemplateId);
  const ids = attributeIds.concat(shapeIds);
  ids.sort((a, b) => {
    const aValue = cardTemplateAttributeDb.cardTemplateAttributes[a] || cardTemplateShapeDb.cardTemplateShapes[a];
    const bValue = cardTemplateAttributeDb.cardTemplateAttributes[b] || cardTemplateShapeDb.cardTemplateShapes[b];
    return bValue.z - aValue.z;
  })
  const values = ids.map(id => {
    return cardTemplateAttributeDb.cardTemplateAttributes[id] ? cardTemplateAttributeDb.cardTemplateAttributes[id] : cardTemplateShapeDb.cardTemplateShapes[id];
  });

  return [ids, values];
}

export default useCardTemplateAttributeDbs;
